import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/ui/table';
import { formatNumber } from '@/shared/utils/format-utils';
import {
  INVENTORY_FORECAST_USAGE_MONTHS,
  OrganizationInventoryForecast,
} from '@/domains/global-dashboard/sections/terminals/inventory-forecast-utils';
import { getTerminalTypeTextColorClass, TERMINAL_TYPE_INFO } from '@/shared/utils/color-utils-terminals';

export type InventoryForecastCardProps = {
  organizationsForecast: OrganizationInventoryForecast[];
};

export function InventoryForecastCard({ organizationsForecast }: InventoryForecastCardProps) {
  return (
    <Card className="border-amber-200/80 dark:border-amber-900/50">
      <CardHeader className="p-4 space-y-2">
        <div>
          <CardTitle className="text-base">Inventory Forecast</CardTitle>
          <CardDescription>
            Stock forecast based on the trailing <b>{INVENTORY_FORECAST_USAGE_MONTHS} months(including current month)</b> deployments.
          </CardDescription>
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-0 space-y-4">
        <div className="rounded-md border overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-muted font-medium">
                {organizationsForecast.length > 1 && <TableHead>Organization</TableHead>}
                <TableHead>Terminal type</TableHead>
                <TableHead>Avg. units deployed per month</TableHead>
                <TableHead>Current on-hand</TableHead>
                <TableHead className="text-right">Est. remaining stock (months)</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {organizationsForecast.flatMap((organizationForecast) => organizationForecast.specs.map((spec) => (
                <TableRow key={organizationForecast.organizationId + TERMINAL_TYPE_INFO[spec.type].key}>
                  {organizationsForecast.length > 1 && <TableCell className="font-medium">{organizationForecast.name}</TableCell>}
                  <TableCell><span className={getTerminalTypeTextColorClass(spec.type)}>{TERMINAL_TYPE_INFO[spec.type].value}</span></TableCell>
                  <TableCell>{formatNumber(spec.avgMonthlyNewDeployments)}</TableCell>
                  <TableCell>{formatNumber(spec.currentOnHand)}</TableCell>
                  <TableCell className="text-right">{spec.monthsOfStockRemaining}</TableCell>
                </TableRow>
              )))}
            </TableBody>
          </Table>
        </div>
        <div className="text-sm space-y-3">
          <p className="font-medium">To ensure uninterrupted service, you may:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Transfer available terminals from markets with surplus inventory</li>
            <li>
              Request new terminals by contacting{' '}
              <a href="mailto:support@orbius.com" className="text-primary underline underline-offset-2">
                support@orbius.com
              </a>
            </li>
          </ul>
        </div>
      </CardContent>
    </Card>
  );
}
